<template>
    <div class="col-sm-12 col-md-6 col-lg-4">
        <card>
            <base-input
                    :value="voicemailbox.label"
                    label="Name"
                    required
                    name="name"
                    v-validate="'required|min:3|max:50'"
                    @input="handleNameInputChange"
                    :error="getError('name')"
            ></base-input>

            <div class="">
                <div>
                    <p class="category">Send to email?</p>
                    <base-switch v-model="isRecordingEnabled" on-text="YES" off-text="NO"></base-switch>
                </div>
                <div v-if="isRecordingEnabled" class="form-group offset-1 ">
                    <base-input label="Email"
                                type="email"
                                placeholder="Enter email"
                                class="animated"
                                v-bind:class="{fadeInRight: isRecordingEnabled}"
                                name="email"
                                @input="dirty = true"
                                :error="getError('email')"
                                v-validate="'required|email'"
                                v-model="voicemailbox.email"
                    >
                        <small slot="helperText" id="emailHelp" class="form-text text-muted">Messages left in this
                            voicemailbox
                            will be
                            sent to this address.
                        </small>
                    </base-input>
                    <p class="category">Include recording in email?</p>
                    <base-switch v-model="voicemailbox.attachment" on-text="YES" off-text="NO"
                                 v-on:input="dirty = true"></base-switch>
                </div>

            </div>

            <base-input label="PIN"
                        type="text"
                        placeholder="Enter PIN"
                        name="pin"
                        max="4"
                        :error="getError('pin')"
                        @input="dirty = true"
                        v-validate="'required|digits:4'"
                        v-model="voicemailbox.pin"
            >
                <small slot="helperText" id="pinHelp" class="form-text text-muted">You'll need this pin to listen to
                    your voicemails or manage it.
                </small>
            </base-input>
            <base-input label="Timezone">
                <select
                        id="timezoneselect"
                        placeholder="Timezone"
                        v-model="voicemailbox.timezone"
                        class="form-control"
                        @change="dirty = true"
                        size="small"
                        name="timezone">
                    <option class="select-primary" value="Europe/Brussels">Europe/Brussels</option>
                    <option class="select-primary" value="America/New_York">America/New_York</option>
                </select>
            </base-input>
            <div v-if="voicemailbox.recording">
                <base-input label="Current Recording"
                >
                    <vue-plyr :options="{'controls': [ 'play','progress', 'current-time', 'mute','download']}">
                        <audio>
                            <source :src="voicemailbox.recording" type="audio/wav"/>
                        </audio>
                    </vue-plyr>
                    <small slot="helperText" id="currentRecordingHelp" class="form-text text-muted">This recording
                        currently plays when you someone reaches your voicemailbox.
                    </small>
                </base-input>
            </div>

            <div v-if="!voicemailbox.recording">
                <base-input label="No custom recording" class="mb-5">
                    <span></span>
                </base-input>
            </div>

            <hr>
            <h4>Upload a custom recording.</h4>
            <el-upload
                    class="upload-demo"
                    ref="upload"
                    :multiple="false"
                    accept="audio/*"
                    :limit="1"
                    :auto-upload="false"
                    :on-change="playFile"
                    :on-remove='removeFile'
                    action="">
                <base-button type="info" slot="trigger" size="small">Select recording</base-button>
                <div class="el-upload__tip" slot="tip">Only audio files with a filesize less than 5MB.</div>
            </el-upload>
            <vue-plyr v-if="recording" :options="{'controls': [ 'play','progress', 'duration', 'mute', 'volume']}">
                <audio>
                    <source :src="recording" type="audio/wav"/>
                </audio>
            </vue-plyr>


            <div slot="footer">
                <div class="row">
                    <div class="col">
                        <base-button class="left" :loading="saving" :disabled="!dirty"
                                     @click="save" type="primary">
                            Save
                        </base-button>



                        <base-button icon @click="remove" type="danger" :loading="removing"
                                     class="right">
                            <font-awesome-icon v-if="!removing" :icon="['fal','trash']"></font-awesome-icon>
                        </base-button>
                        <base-button class="middle" :loading="removingMessages"
                                     @click="removeMessages" type="warning">
                            Remove all messages
                        </base-button>

                    </div>
                </div>

            </div>
        </card>
    </div>
</template>
<script>
    import DeviceNumberSelector from "../Ringgroup/DeviceNumberSelector"
    import swal from 'sweetalert2';
    import BaseSwitch from "../../components/BaseSwitch";

    export default {
        name: 'VoicemailboxCard',
        components: {
            DeviceNumberSelector,
            BaseSwitch
        },
        props: {
            initialVoicemailbox: {}
        },
        computed: {},
        data() {
            return {
                dirty: false,
                removing: false,
                saving: false,
                removingMessages: false,
                voicemailbox: null,
                origName: '',
                recording: null,
                file: null,
                isRecordingEnabled: false,
                isAttachmentEnabled: false,
            }
        },
        created() {
            this.voicemailbox = JSON.parse(JSON.stringify(this.initialVoicemailbox));
            this.origName = this.voicemailbox.label;
            this.isRecordingEnabled = this.voicemailbox.email !== '' && this.voicemailbox.email != null;
        },
        methods: {
            removeFile(file, filelist) {
                this.recording = null;
                this.file = null;
            },
            playFile(file, filelist) {
                var binaryData = [];
                binaryData.push(file.raw);
                this.file = file;
                this.recording = window.URL.createObjectURL(new Blob(binaryData, {type: "audio/mp3"}));
                this.dirty = true;
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            handleNameInputChange(value) {
                this.voicemailbox.label = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            save() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.saving = true;
                        let data = this.voicemailbox;
                        let name = this.voicemailbox.name;
                        let file = null;
                        if (this.file) {
                            file = this.file.raw;
                        }

                        if (this.isRecordingEnabled !== true) {
                            this.$delete(this.voicemailbox, 'email');
                        }

                        this.$store.dispatch('voicemail/saveBox', {name, data, file}).then(() => {
                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your voicemailbox: ' + data.label + ' was saved!',
                                type: "success",
                                iconClass: "fal fa-save",
                                title: "Saved!"
                            });

                            this.dirty = false;
                            this.saving = false;
                        }).catch((err) => {
                            console.log(err);
                            console.log(err.status);
                            this.$notify({
                                position: "bottom-right",
                                message: err.data.errors[Object.keys(err.data.errors)[0]][0],
                                type: "error",
                                duration: 5000,
                                iconClass: "fal fa-times",
                                title: "Error!"
                            },);
                            this.saving = false;
                        });
                    }
                })
            },
            remove() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "This will delete the entire Voicemailbox and all of its messages! You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.removing = true;
                        let name = this.voicemailbox.name;
                        this.$store.dispatch('voicemail/removeBox', {name}).then(() => {
                            this.$notify({
                                message: 'Your voicemailbox: ' + this.voicemailbox.label === null ? this.voicemailbox.name : this.voicemailbox.label + ' was removed!',
                                type: "success",
                                iconClass: "fal fa-trash",
                                title: "Removed!"
                            });

                            this.dirty = false;
                            this.saving = false;
                            this.removing = false;
                            this.$emit('removed');
                        }).catch(() => {
                            this.$notify({
                                message: 'Failed to remove!',
                                type: "error",
                                iconClass: "fal fa-times",
                                title: "Error!"
                            });
                            this.removing = false;
                        })
                    }
                });
            },
            removeMessages() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "This will delete all messages in this voicemailbox! You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete them!'
                }).then((result) => {
                    if (result.value) {
                        this.removingMessages = true;
                        let name = this.voicemailbox.name;
                        this.$store.dispatch('voicemail/deleteVoiceMessages', {name}).then(() => {
                            this.$notify({
                                message: 'Messages have been removed!',
                                type: "success",
                                iconClass: "fal fa-trash",
                                title: "Messaged removed!"
                            });

                            this.removingMessages = false;
                            this.$emit('removed');
                        }).catch(() => {
                            this.$notify({
                                message: 'Failed to remove messages!',
                                type: "error",
                                iconClass: "fal fa-times",
                                title: "Error!"
                            });
                            this.removingMessages = false;
                        })
                    }
                });
            },
        },
    }
</script>
